module.exports = __webpack_public_path__ + "static/media/YS_badgeInnovator.56979bd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YS_badgeInnovator.png
// module id = 1429
// module chunks = 0